import { Translation } from '@ps/web-shared-components';
import type { FC } from 'react';
import React from 'react';

import { TXTWCL_Bet_ID } from './BetIdRow.messages.json';
import styles from './BetIdRow.scss';

interface Props {
  betReceiptId?: string;
}

export const BetIdRow: FC<Props> = ({ betReceiptId }) => (
  <p className={styles.container}>
    <span>
      <Translation {...TXTWCL_Bet_ID} />:
    </span>{' '}
    <span className={styles.value}>{betReceiptId}</span>
  </p>
);
